import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import jsonData from '../Cities.json';


function ContactInfoEdit({ dragHandleProps }) {
  const { t } = useTranslation();

  let userId = Cookies.get('userId');
  let UserToken = Cookies.get('UserSpecialToken');
  let LanguageSelected = Cookies.get('LanguageSelected');

  const apiUrl = process.env.REACT_APP_BACKEND_URL

  const [options, setOptions] = useState([])


  const [Done, setDone] = useState(false)
  const [InputsErrors, setInputsErrors] = useState([])

  const [ContactInfoModal, setContactInfoModal] = useState(false)
  const [EditContactInfoModal, setEditContactInfoModal] = useState(false)

  const [phoneNumbers, setPhoneNumbers] = useState([{ prefixPhone: '+212', phone: '' }]);
  const [phoneNumbersUpdate, setPhoneNumbersUpdate] = useState([{ id: 2, prefixPhone: '+212', phone: '' }]);
  const [phones, setphones] = useState([])


  const [ContactInfo, setContactInfo] = useState({})
  const [ContactContent, setContactContent] = useState([])

  const [contactId, setContactId] = useState()
  const [isFetching, setIsFetching] = useState(false);

  const AddingContactInfo = (e) => {
    return setContactInfo({ ...ContactInfo, [e.target.name]: e.target.value })

  }
  useEffect(() => {
    if (ContactInfoModal || EditContactInfoModal) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }
  }, [ContactInfoModal, EditContactInfoModal]);

  useEffect(() => {
    setOptions(jsonData.data)

  }, []);


  const SetContactToUpdateDefaultValues = () => {
    const contact = ContactContent[0]
    return setContactInfo({ ...ContactInfo, contactId: contact.id, email: contact.email, localisation: contact.location, site: contact.website })

  }
  useEffect(() => {
    if (ContactInfoModal == true || EditContactInfoModal == true) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');

    }
  }, [ContactInfoModal, EditContactInfoModal])

  useEffect(() => {
    setContactInfo({ ...ContactInfo, phoneNumbers: phoneNumbers })
  }, [phoneNumbers])

  useEffect(() => {
    setContactInfo({ ...ContactInfo, phoneNumbersUpdate: phoneNumbersUpdate })
  }, [phoneNumbersUpdate])


  useEffect(() => {
    fetch(`${apiUrl}/GetContactInfo`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${UserToken}`


      },
      body: JSON.stringify({ user_id: userId })


    })
      .then(response => response.json())
      .then(result => {
        if (result.success) {
          setContactContent([result.data])
          setPhoneNumbersUpdate(result.PhoneNumbers)
          setContactInfo({ ...ContactInfo, user_id: userId })
          setphones(result.PhoneNumbers)


        }
      })
  }, [Done])

  function isStateFilledOrContainsMore(obj) {
    const keys = Object.keys(obj);

    // Check if there are more keys than just 'phoneNumbersUpdate'
    if (keys.length > 1) {
        return true;
    }

    // Check if 'phoneNumbersUpdate' is not an empty array
    if (keys.includes('phoneNumbersUpdate') && Array.isArray(obj.phoneNumbersUpdate) && obj.phoneNumbersUpdate.length > 0) {
        return true;
    }

    return false;
}



  const addPhoneNumber = () => {
    setPhoneNumbers([...phoneNumbers, { prefixPhone: '+212', phone: '' }]);
  };

  const removePhoneNumber = (index) => {
    const updatedPhoneNumbers = phoneNumbers.filter((_, i) => i !== index);
    setPhoneNumbers(updatedPhoneNumbers);
  };

  const handlePhoneNumberChange = (index, field, value) => {
    const updatedPhoneNumbers = [...phoneNumbers];
    updatedPhoneNumbers[index][field] = value;
    setPhoneNumbers(updatedPhoneNumbers);
  };

  const addPhoneNumberUpdate = () => {
    setPhoneNumbersUpdate([...phoneNumbersUpdate, { id: null, prefixPhone: '+212', phone: '' }]);
  };

  const handlePhoneNumberUpdateChange = (index, field, value) => {
    const updatedPhoneNumbers = [...phoneNumbersUpdate];
    updatedPhoneNumbers[index][field] = value;
    setPhoneNumbersUpdate(updatedPhoneNumbers);
  };
  const handleDeletePhoneNumber = (index) => {
    const updatedPhoneNumbers = [...phoneNumbersUpdate];
    const removedPhoneNumber = updatedPhoneNumbers.splice(index, 1)[0];

    if (removedPhoneNumber.id) {
      updatedPhoneNumbers.push({ id: removedPhoneNumber.id, _delete: true });
    }

    setPhoneNumbersUpdate(updatedPhoneNumbers);
  };





  const StoreContactInfo = (e) => {

     setIsFetching(true);

      e.preventDefault()
      fetch(`${apiUrl}/StoreContactInfo`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'Authorization': `Bearer ${UserToken}`


        },
        body: JSON.stringify(ContactInfo)
      })
        .then(response => response.json())
        .then(result => {
          if (result.success) {
            setDone(!Done)
            setInputsErrors([])
            setPhoneNumbers([{ prefixPhone: '+212', phone: '' }])
            setContactInfoModal(false)
            toast.success(result.message, {
              position: toast.POSITION.CENTER
            });
            setContactInfo({phoneNumbersUpdate: []})

          }
          else {
            setInputsErrors(result.errors)


          }
        })
        .finally(() => {
          setIsFetching(false);

        });

    
  }

  const UpdateContactInfo = (e) => {
    setIsFetching(true);

    e.preventDefault()
    fetch(`${apiUrl}/UpdateContactInfo`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${UserToken}`


      },
      body: JSON.stringify(ContactInfo)
    })
      .then(response => response.json())
      .then(result => {
        if (result.success) {
          setContactInfo('')
          setInputsErrors([])
          setPhoneNumbersUpdate({ id: null, prefixPhone: '+212', phone: '' })
          setDone(!Done)
          setEditContactInfoModal(false)
          toast.success(result.message, {
            position: toast.POSITION.CENTER
          });

        }
        else {
          setInputsErrors(result.errors)

        }
      })
      .finally(() => {
        setIsFetching(false);
      });
  }

  const DeleteContactInfo = (e, id) => {
    e.preventDefault()

    fetch(`${apiUrl}/DeleteContactInfo`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${UserToken}`


      },
      body: JSON.stringify({ contactId: id })
    })
      .then(response => response.json())
      .then(result => {
        if (result.success) {
          setDone(!Done)

        }
      })
  }

  function formatPhoneNumber(phoneNumber) {
    phoneNumber = phoneNumber.toString();
    const cleanedNumber = phoneNumber.replace(/\D/g, '');
    const formattedNumber = cleanedNumber.replace(/(\d{3})(?=\d)/g, '$1 ');

    return formattedNumber;
  }

  return (
    <div className={`${LanguageSelected == 'ar' ? 'rtlDiv' : ''}`}>
      <section className="info   sections rounded-xl pt-3 pb-3 pl-3 m-3">
        <div className='flex justify-between'>
          <div className="pb-2">
            <h1 className={`${LanguageSelected == 'ar' ? 'title title--h1 first-title title__separate text-theme right-4' : 'title left-0 title--h1 first-title title__separate text-theme'}`}>{t("Informations de contact")}</h1>
          </div>
          {ContactContent != '' &&

            ContactContent.map(contact => {
              return (

                <div className="flex items-center -mt-5">
                  <svg onClick={() => { setEditContactInfoModal(true); setContactId(contact.id); SetContactToUpdateDefaultValues() }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
                  </svg>
                  <svg onClick={(e) => { DeleteContactInfo(e, contact.id) }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className={`${LanguageSelected == 'ar' ? 'w-6 mr-0.5' : 'w-6 mr-5'}`}>
                    <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                  </svg>
                </div>
              )
            })


          }
        </div>

        {ContactContent && phones &&
          ContactContent.map(contact => {
            return (
              <div className="p-2 w-full">
                <div className="grid grid-cols-1 gap-4 pr-2.5">

                  {contact?.location != null &&
                    <a href={`https://maps.google.com/maps?q=${encodeURIComponent(contact.location)}`} target='_blank' className="col-span-12 sm:col-span-6 md:col-span-3 w-full">
                      <div className="flex flex-row div-sections  rounded p-3">
                        <div className="flex items-center mt-1 justify-center flex-shrink-0 h-12 w-12 rounded-xl bg-#B8996C text-white">
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width={24} height={24}>
                            <path d="M12 2C8.13 2 5 5.13 5 9c0 3.07 1.81 6.77 5.89 12.92a1 1 0 0 0 1.22.51c.37-.12.72-.32 1.04-.57C17.19 15.77 19 12.07 19 9c0-3.87-3.13-7-7-7zm0 10c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z" />
                          </svg>
                        </div>
                        <div className={`flex items-center ${LanguageSelected == 'ar' ? 'mr-2' : 'ml-2'}`}>
                          <div className="text-sm text-about" dir="auto">{contact.location}</div>
                        </div>
                      </div>
                    </a>
                  }
                  {contact?.email != null &&

                    <div className="col-span-12 sm:col-span-6 md:col-span-3 w-full ">

                      <div className="flex flex-row div-sections  rounded p-3 ">
                        <div className="flex items-center mt-1 justify-center flex-shrink-0 h-12 w-12 rounded-xl bg-#B8996C text-white">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M7.875 14.25l1.214 1.942a2.25 2.25 0 001.908 1.058h2.006c.776 0 1.497-.4 1.908-1.058l1.214-1.942M2.41 9h4.636a2.25 2.25 0 011.872 1.002l.164.246a2.25 2.25 0 001.872 1.002h2.092a2.25 2.25 0 001.872-1.002l.164-.246A2.25 2.25 0 0116.954 9h4.636M2.41 9a2.25 2.25 0 00-.16.832V12a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 12V9.832c0-.287-.055-.57-.16-.832M2.41 9a2.25 2.25 0 01.382-.632l3.285-3.832a2.25 2.25 0 011.708-.786h8.43c.657 0 1.281.287 1.709.786l3.284 3.832c.163.19.291.404.382.632M4.5 20.25h15A2.25 2.25 0 0021.75 18v-2.625c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125V18a2.25 2.25 0 002.25 2.25z" />
                          </svg>
                        </div>
                        <a href={`mailto:${contact.email}`} className={`flex items-center ${LanguageSelected == 'ar' ? 'mr-2' : 'ml-2'}`}>
                          <div className="text-sm text-about" dir="ltr">{contact.email}</div>
                        </a>
                      </div>
                    </div>
                  }

                  {contact?.website != null &&
                    <a href={contact.website} target='_blank' className="col-span-12 sm:col-span-6 md:col-span-3 w-full">
                      <div className="flex flex-row div-sections  rounded p-3">
                        <div className="flex items-center mt-1 justify-center flex-shrink-0 h-12 w-12 rounded-xl bg-#B8996C text-white">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0112 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 013 12c0-1.605.42-3.113 1.157-4.418" />
                          </svg>
                        </div>
                        <div className={`flex items-center ${LanguageSelected == 'ar' ? 'mr-2' : 'ml-2'}`}>
                          <div className="text-sm text-about" dir="ltr">{contact.website}</div>
                        </div>
                      </div>
                    </a>
                  }

                  {phones &&
                    phones.map((phoneNumber, index) => {
                      if (phoneNumber && phoneNumber.phone != null) {
                        return (
                          <a key={index} className="col-span-12 sm:col-span-6 md:col-span-3 w-full">
                            <div className="flex flex-row div-sections  rounded p-3">
                              <div className="flex items-center mt-1 justify-center flex-shrink-0 h-12 w-12 rounded-xl bg-#B8996C text-white">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className={`${LanguageSelected == 'ar' ? 'w-6 h-6 text-theme text-xl ml-3' : 'w-6 h-6 text-theme text-xl mr-3'}`}>
                                  <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.970c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
                                </svg>
                              </div>
                              <div className={`flex items-center ${LanguageSelected == 'ar' ? 'mr-2' : 'ml-2'}`}>
                                <div className="text-sm text-about" dir="ltr">{phoneNumber.prefixPhone} {formatPhoneNumber(phoneNumber.phone)}
                                </div>
                              </div>
                            </div>
                          </a>
                        )
                      }

                    })}

                </div>


              </div>
            )
          })

        }
        {ContactContent == '' &&
          <a onClick={() => { setContactInfoModal(true) }}>

            <main className="flex p-5   items-center justify-center  ">
              <label htmlFor="dropzone-file-contact" className="mx-auto cursor-pointer flex w-full max-w-lg flex-col items-center rounded border-2 border-dashed border-gold div-sections p-6 text-center">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6 text-theme">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <p className="mt-2 text-about tracking-wide">{t("Entrez vos coordonnées.")} </p>
              </label></main></a>
        }
        <div className="drag-handle flex justify-center pt-2 text-theme" {...dragHandleProps}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6">
            <path fill-rule="evenodd" d="M17.303 5.197A7.5 7.5 0 006.697 15.803a.75.75 0 01-1.061 1.061A9 9 0 1121 10.5a.75.75 0 01-1.5 0c0-1.92-.732-3.839-2.197-5.303zm-2.121 2.121a4.5 4.5 0 00-6.364 6.364.75.75 0 11-1.06 1.06A6 6 0 1118 10.5a.75.75 0 01-1.5 0c0-1.153-.44-2.303-1.318-3.182zm-3.634 1.314a.75.75 0 01.82.311l5.228 7.917a.75.75 0 01-.777 1.148l-2.097-.43 1.045 3.9a.75.75 0 01-1.45.388l-1.044-3.899-1.601 1.42a.75.75 0 01-1.247-.606l.569-9.47a.75.75 0 01.554-.68z" clip-rule="evenodd" />
          </svg>

        </div>
      </section>

      {ContactInfoModal &&

        <div>

          <div className="minscreen h-full animated fadeIn faster  fixed  left-0 top-0 flex justify-center items-center inset-0 z-50 forms-info ">
            <div className="absolute top-0 right-0 p-4">
              <a className='w-12 h-12' onClick={() => { setContactInfoModal(false); setInputsErrors([]); setPhoneNumbers([{ prefixPhone: '+212', phone: '' }]) }}>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-theme cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                </svg>
              </a>
            </div>
            <div className="w-full max-w-sm   p-8 rounded-md">
              <h2 className="text-3xl mb-2 text-theme">{t("Informations de contact")}</h2>
              <form className="space-y-6 text-about">

                <div>
                  <label htmlFor="email" className="textModal">{t("Ajoutez les coordonnées professionnelles que vous souhaitez partager avec vos rencontres")}</label>
                  <div className="mt-5">
                    <input onChange={(e) => { AddingContactInfo(e) }} type="text" id="localisation" name="localisation" className="appearance-none block w-full placeholder-sm h-14 px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm" placeholder={t("Entrer Votre adresse")} required />
                    <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('localisation') && InputsErrors.localisation}</span></p>

                  </div>

                </div>
                <div className="mt-5">
                  <input onChange={(e) => { AddingContactInfo(e) }} type="email" id="email" name="email" className="appearance-none block w-full placeholder-sm h-14 px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm" placeholder={t("Entrer votre adresse email")} required />
                  <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('email') && InputsErrors.email}</span></p>

                </div>
                <div className="mt-5 ">
                  <input onChange={(e) => { AddingContactInfo(e) }} type="text" id="site" name="site" className="appearance-none block w-full placeholder-sm h-14 px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm" placeholder={t("Entrer le lien de votre siteWeb")} required />
                  <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('site') && InputsErrors.site}</span></p>

                </div>

                <div className="flex ltrDiv flex-wrap items-center justify-center gap-2 ">


                  {phoneNumbers &&
                    phoneNumbers.map((phoneNumber, index) => (
                      <div className='grid grid-cols-10 gap-2 '>
                        <div className="col-span-3">
                          <div className=" w-full">
                            <select value={phoneNumber.prefixPhone} onChange={(e) => handlePhoneNumberChange(index, 'prefixPhone', e.target.value)} type="text" id="prefixPhone" className="appearance-none   w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active  sm:text-sm"  >
                              <option disabled selected>{t("Prefix")}</option>
                              {options.map((option) => (
                                <option key={option.prefix} value={option.prefix}>
                                  {`${option.prefix} ${option.country}`}
                                </option>
                              ))}
                            </select>
                            <p className="text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('prefixPhone') && InputsErrors.prefixPhone}</span></p>

                          </div>
                        </div>
                        <div className='col-span-6'>
                          <div className=" w-full">
                            <input value={phoneNumber.phone}
                              onChange={(e) => handlePhoneNumberChange(index, 'phone', e.target.value)} type="number" id="phone" className="appearance-none  w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active  sm:text-sm" placeholder={t("Entrer votre numero de telephone")} required />
                            <p className="text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('phone') && InputsErrors.phone}</span></p>

                          </div>
                        </div>
                        <div className='col-span-1 flex justify-center items-center'>
                          <a onClick={() => removePhoneNumber(index)}>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-6 text-theme">
                              <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                            </svg>

                          </a>
                        </div>
                      </div>
                    ))
                  }
                  <div className='flex w-full justify-start items-center text-theme mt-2'>

                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-6">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>

                    <a onClick={addPhoneNumber} className='cursor-pointer'><p className='ml-2 text-md font-md  text-theme w-full'>{t("Ajouter Un Numero")}</p></a>

                  </div>

                </div>


                <div>
                  <button onClick={(e) => { StoreContactInfo(e) }} disabled={isFetching} type="submit" className="w-full btn-edit">
                    {t("enregistrer")}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>


      }


      {EditContactInfoModal &&

        <div>

          <div className="minscreen h-full animated fadeIn faster  fixed  left-0 top-0 flex justify-center items-center inset-0 z-50 forms-info ">
            <div className="absolute top-0 right-0 p-4">
              <a className='w-12 h-12' onClick={() => { setEditContactInfoModal(false); setInputsErrors([]) }}>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-theme cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                </svg>
              </a>
            </div>
            <div className="w-full max-w-sm  p-8 rounded-md">
              <h2 className="text-3xl text-theme mb-2">{t("Modifier les informations de contact")}</h2>
              <form className="space-y-6 text-about">
                <div>
                  <label htmlFor="email" className="textModal">{t("Modifiez les coordonnées professionnelles que vous souhaitez partager avec vos rencontres")}</label>

                  <div className="mt-5">
                    <input defaultValue={ContactContent[0].location} onChange={(e) => { AddingContactInfo(e) }} type="text" id="localisation" name="localisation" className="appearance-none block w-full placeholder-sm h-14 px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm" placeholder={t("Entrer Votre adresse")} required />
                    <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('localisation') && InputsErrors.localisation}</span></p>

                  </div>
                </div>
                <div className="mt-5">
                  <input defaultValue={ContactContent[0].email} onChange={(e) => { AddingContactInfo(e) }} type="email" id="email" name="email" className="appearance-none block w-full placeholder-sm h-14 px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm" placeholder={t("Entrer votre adresse email")} required />
                  <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('email') && InputsErrors.email}</span></p>

                </div>
                <div className="mt-5">
                  <input defaultValue={ContactContent[0].website} onChange={(e) => { AddingContactInfo(e) }} type="text" id="site" name="site" className="appearance-none block w-full placeholder-sm h-14 px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm" placeholder={t("Entrer le lien de votre siteWeb")} required />
                  <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('site') && InputsErrors.site}</span></p>

                </div>

                <div className="flex ltrDiv flex-wrap items-center justify-center gap-2 ">

                  {Array.isArray(phoneNumbersUpdate) && (

                    phoneNumbersUpdate.map((phoneNumber, index) => (
                      phoneNumber._delete ? null : (
                        <div className='grid grid-cols-10 gap-2'>
                          <div className="col-span-3 ">
                            <div className=" w-full">
                              <select value={phoneNumber.prefixPhone} onChange={(e) => handlePhoneNumberUpdateChange(index, 'prefixPhone', e.target.value)} type="text" id="prefixPhone" className="appearance-none   w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active  sm:text-sm"  >
                                <option disabled selected>{t("Prefix")}</option>
                                {options.map((option) => (
                                  <option key={option.prefix} value={option.prefix}>
                                    {`${option.prefix} ${option.country}`}
                                  </option>
                                ))}
                              </select>                              <p className="text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('prefixPhone') && InputsErrors.prefixPhone}</span></p>

                            </div>
                          </div>
                          <div className='col-span-6 ml-2'>
                            <div className=" w-full">
                              <input value={phoneNumber.phone}
                                onChange={(e) => handlePhoneNumberUpdateChange(index, 'phone', e.target.value)} type="number" id="phone" className="appearance-none  w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active  sm:text-sm" placeholder={t("Entrer votre numero de telephone")} required />
                              <p className="text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('phone') && InputsErrors.phone}</span></p>

                            </div>
                          </div>
                          <div className='col-span-1 flex justify-center items-center'>
                            <a onClick={() => handleDeletePhoneNumber(index)}>
                              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-6 text-theme">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                              </svg>

                            </a>
                          </div>
                        </div>
                      )
                    )))
                  }
                  <div className='flex w-full justify-start items-center text-theme mt-2'>

                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-6">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>

                    <a onClick={addPhoneNumberUpdate} className='cursor-pointer'><p className='ml-2 text-md font-md  text-theme w-full'>{t("Ajouter Un Numero")}</p></a>

                  </div>


                </div>

                <div>
                  <button onClick={(e) => { UpdateContactInfo(e) }} disabled={isFetching} type="submit" className="w-full btn-edit">
                    {t("enregistrer")}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>


      }



    </div>
  )
}

export default ContactInfoEdit